module.exports = __WEBPACK_EXTERNAL_MODULE_0__;


//////////////////
// WEBPACK FOOTER
// external "_"
// module id = 0
// module chunks = 0